import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import BaseEntitiesSearchAutocomplete, {
  BaseEntitiesSearchAutocompleteInheritableProps,
} from "@/common/components/Entity/components/BaseEntitiesSearchAutocomplete";
import AppIcon from "@/common/components/Icons/AppIcon";
import { renderIf } from "@/common/helpers/render/renderIf";
import { AutocompleteOptionType } from "@/common/ts/autocomplete";
import { apiClient } from "@/core/api/ApiClient";
import { ProductLocationDto, ProductLocationGetPaginatedDto } from "@/core/api/generated/v1";

import { productLocationToOption } from "./ProductLocationAutocomplete";

export interface ProductLocationsAutocompleteProps extends BaseEntitiesSearchAutocompleteInheritableProps<ProductLocationDto> {
  searchFilters?: Partial<Omit<ProductLocationGetPaginatedDto, "search" | "includeIds">>;
}

export default function ProductLocationsAutocomplete({
  searchFilters,

  isPreload = true,
  ...otherProps
}: ProductLocationsAutocompleteProps) {
  return (
    <BaseEntitiesSearchAutocomplete
      sx={{ minWidth: 200, flex: 1 }}
      entityToOption={productLocationToOption}
      isPreload={isPreload}
      request={{
        requestFunc: apiClient.productLocationsApi.apiV1ProductLocationsGetPost,
        limit: 25,
        parameters: {
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          productLocationGetPaginatedDto: {
            ...searchFilters,
          },
        },
        combineParameters: (params, newParams) => ({
          ...params,
          productLocationGetPaginatedDto: {
            ...params.productLocationGetPaginatedDto,
            ...newParams,
          },
        }),
        deps: [searchFilters],
      }}
      label='Sales locations'
      placeholder='Search for sales locations...'
      renderOption={(props, option) => {
        return (
          <ListItem {...props}>
            <ListItemIcon>
              {renderIf()
                .if(option.optionType === AutocompleteOptionType.Normal)
                .then(<AppIcon of='productLocation' />)
                .elseif(option.optionType === AutocompleteOptionType.DynamicCreateNew)
                .then(<AppIcon of='add' />)
                .render()}
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <Typography
                    variant={
                      option.optionType === AutocompleteOptionType.DynamicCreateNew
                        ? "subtitle1"
                        : "body1"
                    }
                    component='div'
                  >
                    {option.title}
                  </Typography>
                  {option.data && (
                    <Typography component='div' variant='body2'>
                      <Box>{option.data?.description}</Box>
                      {/* {option?.data?.departmentIds?.id && (
                        <DepartmentInline
                          entityId={option.data.department.id}
                          entity={option.data.department}
                          withIcon={false}
                        />
                      )} */}
                    </Typography>
                  )}
                </>
              }
            />
          </ListItem>
        );
      }}
      {...otherProps}
    />
  );
}
